import * as React from 'react'

import DialogContent        from '@material-ui/core/DialogContent'
import DialogContentText    from '@material-ui/core/DialogContentText'
import DialogTitle          from '@material-ui/core/DialogTitle'
import { withFormik }       from 'formik'
import { FormattedMessage } from 'react-intl'

import { Study }                                 from '../../api'
import asDialog, { InjectedAsDialogProps }       from '../hocs/asDialog'
import EducationalAchievementChunk               from './chunks/EducationalAchievementChunk'
import { genValueMapper, proxyFormikSubmission } from './form-utils'
import educationalAchievementSchema, {
  emptyAchievement,
}                                                from './schemas/educational-achievements.schema'
import asNestedForm                              from './wrappers/asNestedForm'

const formikConfig = {
  validationSchema: educationalAchievementSchema,
  mapPropsToValues: genValueMapper(emptyAchievement),
  handleSubmit:     proxyFormikSubmission,
}

const EducationalAchievementForm = withFormik(
  formikConfig,
)(
  asNestedForm<Study>(
    EducationalAchievementChunk,
  ),
)

interface EducationalAchievementFormProps {
  collect: (values: Study) => void
}

const EducationalAchievementFormDialog = ({
  close,
  collect,
  ...rest
}: InjectedAsDialogProps & EducationalAchievementFormProps) => {
  const phrasing = {
    fillInPrompt:
      (
        <FormattedMessage
          id={'forms.fillInEducationalAchievementPrompt'}
          defaultMessage={'Fill in the information about your educational achievement'}
        />
      ),
    educationalAchievement:
      (
        <FormattedMessage
          id={'forms.educationalAchievement'}
          defaultMessage={'Educational Achievement'}
        />
      ),
  }

  return (
    <>
      <DialogTitle>
        {phrasing.educationalAchievement}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {phrasing.fillInPrompt}
        </DialogContentText>
        <EducationalAchievementForm
          {...rest}
          onSubmit={(values: any) => {
            collect(values)
            close()
          }}
        />
      </DialogContent>
    </>
  )
}

export default asDialog(EducationalAchievementFormDialog)



// WEBPACK FOOTER //
// ./src/components/forms/EducationalAchievementForm.tsx